import React, { useRef, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { useGetListsQuery } from 'app/apis/lists.api';

import RecentDevelopments from './recent-developments';
import QuickSearch from './quick-search';
import HomepageAbout from './about';
import Focus from './focus';

const blockSx = {
  border: '1px solid #E9ECED',
  padding: '16px',
};

const customScrollbar = {
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 2,
  },
  '&:hover': {
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
    },
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
};

const Homepage = () => {
  const { lang } = useParams();
  const { data: lists, isLoading } = useGetListsQuery({ lang });
  const homeElement = useRef();
  const [focusHeight, setFocusHeight] = useState('auto');

  useEffect(() => {
    if (!isEmpty(homeElement.current)) {
      setFocusHeight(`${homeElement.current.offsetHeight}px`);
    }
  }, [homeElement]);

  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={6}>
        <Grid container direction='column' ref={homeElement}>
          <Grid item xs={12} sx={blockSx}>
            <HomepageAbout />
          </Grid>
          <Grid item xs={12} sx={{ ...blockSx, mt: 2 }}>
            <QuickSearch data={lists} isLoading={isLoading} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container direction='column'>
          <Grid item xs={12} sx={{ ...blockSx, ...customScrollbar }} style={{ maxHeight: focusHeight, overflow: 'auto' }} id='focus-box'>
            <Focus data={lists} isLoading={isLoading} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12}>
        <Grid container direction='column'>
          <Grid item xs={12} sx={blockSx} style={{ maxWidth: '100%' }}>
            <RecentDevelopments />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Homepage;
